import React, { useState, useEffect } from 'react'
import {
  Form,
  Pagination,
  Button,
  Modal,
  Card,
  Row,
  Col,
} from 'react-bootstrap'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'

import 'bootstrap/dist/css/bootstrap.min.css'
import { FaBookOpen, FaClipboardList, FaSyncAlt, FaTimes } from 'react-icons/fa'
import { Eye, PencilSquare, Trash } from 'react-bootstrap-icons'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import EditExamSheet from './EditExamSheet'
import Cookies from 'js-cookie'
import axios from 'axios'
import { useAuth } from './AuthContext'
import { Typeahead } from 'react-bootstrap-typeahead'

const DataTable = () => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedClass, setSelectedClass] = useState(null)

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const { user } = useAuth()
  const [courses, setCourses] = useState([])

  const [data, setData] = useState([])
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(100)
  const [showModal, setShowModal] = useState(false)
  const [openMarkingSchemeInput, setOpenMarkingSchemeInput] = useState(false)

  const [newExam, setNewExam] = useState({
    course_id: '',
    exam_name: '',
    start_date: '',
    end_date: '',
    status: '',
    marking_scheme: '',
    passing_marks: '',
    total_marks:"",
    session:""
  })
  const [selectedCourse, setSelectedCourse] = useState()
  const [cancelExam, setCancelExam] = useState(false)
  const [blinkColor, setBlinkColor] = useState('red')
  const[session, setSession]=useState([])
  const [selectedCancelInfo, setSelectedCancelInfo] = useState({
    exam_name: '',
    course_id: '',
  })
  const [confirmCheckBox, setConfirmCheckBox] = useState(false)
  const [selectedExamId, setSelectedExamId] = useState('')

  useEffect(() => {
    const interval = setInterval(() => {
      setBlinkColor((prevColor) => (prevColor === 'red' ? 'blue' : 'red'))
    }, 500)
    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  const fetchAllExam = async () => {
    try {
      const institueId = Cookies.get('institute_id')

      const response = await axios.get(
        BASE_URL+'/get/exam/all',
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user.token}`,
            institute_id: Number(institueId),
          },
        },
      )
      console.log('Response from exams: ', response.data.data)
      setSelectedExamId(response.data.data)
      setData(response.data.data)
    } catch (error) {
      console.error(error.response?.data?.message)
    }
  }

  useEffect(() => {
    fetchAllExam()
  }, [])

  const filteredData = data.filter(
    (exam) =>
      (!selectedCourse || Number(exam.course_id) === Number(selectedCourse)) &&
      Object.values(exam).some((val) =>
        val?.toString().toLowerCase().includes(search.trim().toLowerCase()),
      ),
  )

  // const filteredData = data.filter((exam) => exam.course_id === selectedCourse)

  // console.log('Filtered Data:', filteredData)
  const handleCourseChange = (e) => {
    const courseId = e.target.value
    console.log('Selected Course ID: ', courseId)

    setSelectedCourse(courseId)
  }

  const totalPages = Math.ceil(filteredData.length / itemsPerPage)

  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewExam((prev) => ({ ...prev, [name]: value }))

   
  }

  useEffect(()=>{
    const fetchSession = async ()=>{
      try {
        const res=await ApiEndpoints.getSession()
        console.log("Session resp: ",res.data._year)
        setSession(res.data.session_year)
      } catch (error) {
        console.error(error.response?.data?.message)
      }
    }
    fetchSession()
  },[])

  const getMarkingSchemeDynamic = () => {
    switch (newExam.marking_scheme) {
      case 'number':
        return 'Enter Passing Number'
      case 'grade':
        return 'Enter Passing Grade'
      case 'grade_number':
        return 'Enter Passing Marks'
      default:
        return 'Enter Marking Scheme'
    }
  }
  const statusColor = (status) => {
    switch (status) {
      case 'complete':
        return 'text-success fw-semibold'
      case 'upcoming':
        return 'text-primary fw-semibold'
      case 'cancel':
        return 'text-danger fw-semibold'
      default:
        return 'fw-semibold'
    }
  }
  const handleSave = async () => {
    try {
      const institueId = Cookies.get('institute_id')
      const payload = {
        ...newExam,
        institute_id: Number(institueId),
      }
      console.log('Sending data in payload: ', payload)
      const response = await ApiEndpoints.addExam(payload)
      setNewExam('Response: ', response)
      // setData(response.data)
      // Reset the form after submission
      setNewExam({
        course_id: '',
        exam_name: '',
        start_date: '',
        end_date: '',
        status: '',
      })
      setShowModal(false)

      toast.success(response.data.message)
      fetchAllExam()
    } catch (error) {
      toast.error(error.response?.data?.message)
    }
  }

  const handleRefresh = () => {
    setSelectedCourse('')
    setCurrentPage(1)
    fetchAllExam()
  }
  const handleCancelExam = async (e, examId) => {
    e.preventDefault()
    try {
      console.log('examId', examId)
      const response = await ApiEndpoints.cancelExamById(examId)
      console.log('Response after cancel', response)
      toast.success(response.data.message)
      setCancelExam(false)
    } catch (error) {
      toast.error(error.response?.data?.message)
      setCancelExam(false)
    }
  }
  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">Exams</h2>
          <Button
            variant="light"
            className="fw-bold"
            onClick={() => setShowModal(true)}
          >
            <FaClipboardList size={16} className="me-2" />
            <span>Add New Exam</span>
          </Button>
        </div>
      </div>

      <Row className="g-2 align-items-center justify-content-between mt-4">
        <Col xs={12} md={3}>
          <Form.Group className="text-start fw-bold mb-0">
            <Form.Label>Select Course</Form.Label>
            <Typeahead
              id="course-select"
              labelKey="name"
              onChange={(selected) => {
                const course = selected[0]
                if (course) {
                  handleCourseChange({ target: { value: course.id } })
                } else {
                  handleCourseChange({ target: { value: '' } })
                }
              }}
              placeholder="Select Course"
              options={courses}
              selected={
                selectedCourse
                  ? courses.filter((cs) => cs.id === Number(selectedCourse))
                  : []
              }
            />
          </Form.Group>
        </Col>
        <Col xs="auto">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="w-auto"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row>

      <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
        <p className="text-black m-0">Total Exams : {filteredData.length} </p>
        <Form.Select
          className="w-auto"
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(Number(e.target.value))
            setCurrentPage(1)
          }}
        >
          <option value="100">100 per page</option>
          <option value="200">200 per page</option>
          <option value="300">300 per page</option>
        </Form.Select>
      </div>
      <div className="table-responsive d-none d-md-block">
        <Table className="table table-striped table-bordered table-hover rounded shadow-sm mb-0">
          <Thead className="bg-dark text-white">
            <Tr className="bg-secondary rounded">
              {/* <Th>Sr.</Th> */}
              <Th>Course</Th>
              <Th>Exam Name</Th>
              <Th>Session</Th>
              <Th>Marking Scheme</Th>
              <Th>Passing Marks</Th>
              <Th>Total Marks</Th>
              <Th>Start Date</Th>
              <Th>End Date</Th>
              <Th>Status</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody>
            {currentItems.length > 0 ? (
              currentItems.map((item, index) => (
                <Tr key={index}>
                  {/* <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td> */}
                  <Td>
                    {' '}
                    {courses.find((course) => course.id === item.course_id)
                      ?.name || 'N/A'}
                  </Td>{' '}
                  <Td>{item.exam_name}</Td>
                  <Td> {item.session} </Td>
                  <Td>
                    {item.marking_scheme === 'grade_number'
                      ? 'Grade & Number'
                      : item.marking_scheme === 'grade'
                      ? 'Grade'
                      : item.marking_scheme === 'number'
                      ? 'Number'
                      : ''}
                  </Td>
                  <Td>{item.passing_marks}</Td>
                  <Td>{item.total_marks}</Td>
                  <Td>
                    {item.start_date
                      ? new Date(item.start_date).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric',
                        })
                      : 'N/A'}
                  </Td>{' '}
                  <Td>
                    {item.end_date
                      ? new Date(item.end_date).toLocaleDateString('en-GB', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric',
                        })
                      : 'N/A'}
                  </Td>
                  <Td className={statusColor(item.status)}>
                    {item.status
                      ? item.status.charAt(0).toUpperCase() +
                        item.status.slice(1).toLowerCase()
                      : ''}
                  </Td>
                  <Td className="text-center">
                    <div className="d-flex flex-wrap justify-content-center gap-2">
                      <Button
                        variant="warning"
                        onClick={() => {
                          setSelectedClass(item)

                          setShowEditModal(true)
                        }}
                      >
                        <PencilSquare />
                      </Button>
                      <Button
                        variant="danger"
                        title="Cancel Exam"
                        onClick={() => {
                          const courseName =
                            courses.find((cs) => cs.id === item.course_id)
                              ?.name || ''

                          setConfirmCheckBox(false)
                          setSelectedCancelInfo({
                            id: item.id,
                            exam_name: item.exam_name,
                            courseName: courseName,
                          })
                          setCancelExam(true)
                        }}
                      >
                        <FaTimes />
                      </Button>
                    </div>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan="9" className="text-center">
                  No records found
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
      </div>

      {/* Mobile Card View (below md) */}
      <div className="d-block d-md-none ">
        {currentItems.length > 0 ? (
          currentItems.map((item, index) => (
            <div key={index} className="card mb-2 p-3 shadow-sm ">
              <p className="d-flex justify-content-between">
                <strong>Course:</strong>{' '}
                {courses.find((c) => c.id === item.course_id)?.name || 'N/A'}
              </p>
              <p className="d-flex justify-content-between">
                <strong>Exam Name:</strong> {item.exam_name || 'N/A'}
              </p>
              <p className="d-flex justify-content-between">
                <strong>Marking Scheme:</strong>{' '}
                {item.marking_scheme === 'grade_number'
                  ? 'Grade & Number'
                  : item.marking_scheme === 'grade'
                  ? 'Grade'
                  : item.marking_scheme === 'number'
                  ? 'Number'
                  : 'N/A'}
              </p>
              <p className="d-flex justify-content-between">
                <strong>Start Date:</strong>{' '}
                {item.start_date
                  ? new Date(item.start_date).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'long',
                      year: 'numeric',
                    })
                  : 'N/A'}
              </p>
              <p className="d-flex justify-content-between">
                <strong>End Date:</strong>{' '}
                {item.end_date
                  ? new Date(item.end_date).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'long',
                      year: 'numeric',
                    })
                  : 'N/A'}
              </p>
              <p className="d-flex justify-content-between">
                <strong>Status:</strong>{' '}
                <span className={statusColor(item.status)}>
                  {item.status
                    ? item.status.charAt(0).toUpperCase() +
                      item.status.slice(1).toLowerCase()
                    : 'N/A'}
                </span>
              </p>
              <div className="d-flex justify-content-between">
                <strong>Action:</strong>{' '}
                <Button
                  variant="warning"
                  onClick={() => {
                    setSelectedClass(item)

                    setShowEditModal(true)
                  }}
                >
                  <PencilSquare />
                </Button>
                <Button
                  variant="danger"
                  title="Cancel Exam"
                  onClick={() => {
                    const courseName =
                      courses.find((cs) => cs.id === item.course_id)?.name || ''

                    setConfirmCheckBox(false)
                    setSelectedCancelInfo({
                      id: item.id,
                      exam_name: item.exam_name,
                      courseName: courseName,
                    })
                    setCancelExam(true)
                  }}
                >
                  <FaTimes />
                </Button>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center">No records found</p>
        )}
      </div>

      <div className="d-flex justify-content-end align-items-center">
        <Pagination>
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Modal for Adding Exam */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="bg-secondary">
          <Modal.Title className="text-white">Add New Exam</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Course</Form.Label>
              <Form.Select
                name="course_id"
                value={newExam.course_id}
                onChange={handleInputChange}
              >
                <option value="">Select Course</option>
                {courses.map((course) => (
                  <option key={course.id} value={course.id}>
                    {course.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3 text-start">
              <Form.Label>Exam Name</Form.Label>
              <Form.Control
                type="text"
                name="exam_name"
                value={newExam.exam_name}
                onChange={handleInputChange}
                placeholder="Enter Exam Name"
              />
            </Form.Group>

            <Form.Group className="mb-3 text-start">
              <Form.Label>Marking Scheme</Form.Label>
              <Form.Select
                value={newExam.marking_scheme}
                onChange={(e) => {
                  setNewExam((prev) => ({
                    ...prev,
                    marking_scheme: e.target.value,
                  }))
                  setOpenMarkingSchemeInput(true)
                }}
              >
                <option value="">Select</option>
                <option value="number">Number</option>
                {/* <option value="grade">Grade</option>
                <option value="grade_number">Grade & Number</option> */}
              </Form.Select>
            </Form.Group>
            {openMarkingSchemeInput && (
              <Form.Group className="mb-3 text-start">
                <Form.Label>{getMarkingSchemeDynamic()}</Form.Label>
                <Form.Control
                  type="text"
                  name="passing_marks"
                  value={newExam.passing_marks || ''}
                  onChange={(e) =>
                    setNewExam((prev) => ({
                      ...prev,
                      passing_marks: e.target.value,
                    }))
                  }
                  placeholder={getMarkingSchemeDynamic()}
                />
              </Form.Group>
            )}

            {newExam.passing_marks && (
              <large className="text-danger fst-italic">
                The passing marks cannot be edited later. Please fill it
                carefully.
              </large>
            )}

            <Form.Group className="mb-3 text-start">
              <Form.Label>Total Marks</Form.Label>
              <Form.Control
                type="number"
                name="total_marks"
                value={newExam.total_marks}
                onChange={handleInputChange}
                placeholder="Enter Total Marks"
              />
            </Form.Group>

            <Form.Group className="mb-3 mt-3 text-start">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="start_date"
                value={newExam.start_date}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group className="mb-3 text-start">
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="end_date"
                value={newExam.end_date}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group className="mb-3 text-start">
              <Form.Label>Status</Form.Label>
              <Form.Select
                name="status"
                value={newExam.status}
                onChange={handleInputChange}
              >
                <option value="">Select Status</option>
                <option value="complete">complete</option>
                <option value="upcoming">Upcoming</option>
                <option value="cancel">cancel</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3 text-start">
              <Form.Label>Session</Form.Label>
              <Form.Select
                name="session"
                value={newExam.session}
                onChange={handleInputChange}
              >
                <option value="">Select Session</option>
             {session.map((year, index)=>(
              <option key={index} value={year}>
                {year}
              </option>
             ))}
            </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="success" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for Cancel Exam */}
      <Modal
        show={cancelExam}
        onHide={() => setCancelExam(false)}
        size="lg"
        centered
      >
        <Modal.Header className="bg-danger" closeButton>
          <Modal.Title className="text-white" style={{ letterSpacing: '2px' }}>
            Confirm Cancellation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fw-semibold mt-4 mb-4" style={{ letterSpacing: '2px' }}>
            You are about to cancel the exam{' '}
            <strong className="text-danger">
              {selectedCancelInfo.exam_name?.toUpperCase()}
            </strong>{' '}
            for the course{' '}
            <strong className="text-danger">
              {selectedCancelInfo.courseName?.toUpperCase()}
            </strong>
            .
          </p>
          <hr />
          {/* <p
            style={{
              color: blinkColor,
              marginTop: '5px',
              marginBottom: '10px',
              letterSpacing: '2px',
            }}
          >
            This action cannot be undone. Are you sure you want to proceed?
          </p> */}
          <Form.Check
            className="mt-3 mb-3"
            type="checkbox"
            id="confirmCancel"
            checked={confirmCheckBox}
            onChange={(e) => setConfirmCheckBox(e.target.checked)}
            label="This action cannot be undone. Are you sure you want to proceed?"
          />
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setCancelExam(false)
              }}
            >
              Close
            </Button>
            <Button
              variant="danger"
              disabled={!confirmCheckBox}
              onClick={(e) => {
                console.log('Clicked Exam ID:', selectedCancelInfo.id)
                handleCancelExam(e, selectedCancelInfo.id)
              }}
            >
              Cancel Exam
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
      <EditExamSheet
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        examData={selectedClass}
        refreshExamsData={fetchAllExam}
      />
    </div>
  )
}

export default DataTable
